<template>
  <div
    class="card product-field"
    :class="{
      'border-3 border-primary': checked,
    }"
  >
    <input
      autocomplete="off"
      class="invisible"
      type="checkbox"
      :checked="checked"
      :id="id"
    />

    <div class="card-body d-flex p-2">
      <div class="me-3">
        <slot name="image">
          <img v-if="image" :src="image" :alt="title" />
        </slot>
      </div>

      <div>
        <h5 class="card-title">{{ title }}</h5>
        <p class="card-text text-body-secondary">{{ description }}</p>
      </div>

      <a href="#" class="stretched-link" @click.prevent="handleChange"></a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { uniqueId } from "underscore";
import { useField } from "vee-validate";

type Props = {
  id?: string;
  description: string;
  image?: string;
  name: string;
  productId: string;
  title: string;
};

const props = withDefaults(defineProps<Props>(), {
  id: uniqueId("field-"),
});

const { checked, handleChange } = useField(() => props.name, undefined, {
  type: "checkbox",
  checkedValue: props.productId,
});
</script>

<style lang="scss">
.product-field {
  input[type="checkbox"].invisible {
    width: 0;
    position: absolute;
  }

  & + .product-field {
    margin-top: 1rem;
  }
}
</style>
